import { moduleApi } from "@amtana/module";
import type { EraseStep } from "@amtana/module";

import type {
  AddedListProspects,
  AddListProspectsInput,
  Count,
  FilterList,
  FilterLists,
  ListDefinition,
  UpdateListInput,
} from "./list.schemas.ts";

/** Every call is scoped to the caller's active organization (ADR-001 §5); `userId` is the author. */
type ForOrganization = { readonly userId: string; readonly organizationId: string };

export interface ListApi extends EraseStep {
  /** The current project's filters. */
  list(input: ForOrganization): Promise<FilterLists>;
  get(input: ForOrganization & { readonly listId: string }): Promise<FilterList>;
  create(input: ForOrganization & ListDefinition): Promise<FilterList>;
  /** Saves the new definition and rebuilds the filter. */
  update(input: ForOrganization & UpdateListInput): Promise<FilterList>;
  rebuild(input: ForOrganization & { readonly listIds: readonly string[] }): Promise<Count>;
  remove(input: ForOrganization & { readonly listIds: readonly string[] }): Promise<Count>;
  moveToProject(
    input: ForOrganization & { readonly listIds: readonly string[]; readonly projectId: string },
  ): Promise<Count>;
  /** Puts prospects on the list of this name in the current project, each with its note, making
   * it as a picked list when there is none (D603). A list made by its rules is refused as
   * `list_not_picked`; a prospect not in the organization as `list_prospects_unknown`.
   * `agentId` names the agent that added them, when one did. */
  addProspects(
    input: ForOrganization & AddListProspectsInput & { readonly agentId?: string },
  ): Promise<AddedListProspects>;
  /** Operator-only (D053): no transport door. Stamps rows left over from before S1.03. */
  backfillOrganizationId(): Promise<{ readonly assigned: number }>;
}

export const ListApi = moduleApi<ListApi>()("list");
